module.exports = __webpack_public_path__ + "static/media/s11.28102714.ogg";